import _ from 'lodash';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';
import { connect } from 'react-redux';
import duration from 'dayjs/plugin/duration';
import FileBase64 from '../../../Utils/FileUpload';
import { constant } from '../../../Utils/constants';
import React, { useEffect, useRef, useState } from 'react';
import HierarchyModal from '../../../Widgets/HierarchyModal';
import translation from '../../../../../commons/translation';
import InputComponent from '../../../Widgets/InputComponent';

import { DeleteOutlined, QuestionCircleOutlined } from '@ant-design/icons';
import { Toolsform, LaborForm, MaterialForm, ItemForm, FieldTypeForm } from './WorkOrderTasks';
import {
  Form,
  message,
  Col,
  Collapse,
  Popconfirm,
  Select,
  Tabs,
  DatePicker,
  Drawer,
  Divider,
  Space,
  Tooltip,
  Button
} from 'antd';
import {
  getDeviceList,
  // getOrganisationsList,
  // getSitesList,
  getTaskList,
  getTaskById,
  filterTaskByReference,
  // getHierarchyList,
  _getUOMList,
  getUsersList,
  getSkillTypeList
} from '../../../Utils/FormCalls';
//import { useForm } from 'antd/es/form/Form';
const { Panel } = Collapse;
const { Option } = Select;
const { TabPane } = Tabs;

const WorkOrderJobPlanes = (props) => {
  dayjs.extend(duration);
  dayjs.extend(utc);
dayjs.extend(timezone);
  const [deviceList, setDeviceList] = useState([]);
  const deviceId = useState(null);
  const [treeData, setTreeData] = useState([]);
  const [visible, setVisible] = useState(false);
  const [usersList, setUsersList] = useState([]);
  const [taskList, setTaskList] = useState([]);
  const [SkillTypeList, setSkillTypeList] = useState([]);
  const [fileUploadList, setFileUploadList] = useState([]);
  const [recordData, setRecordData] = useState(props.formObject?.TaskData || []);
  const [formObject, setFormObject] = useState(props.formObject || {});
  const [workOrderStatus, setWorkOrderStatus] = useState(props.workOrderStatus);
  const [fileData, setFileData] = useState(props.fileData || new FormData());
  const [translationCache, setTranslationCache] = useState(props.translationCache || {});
  // const [hierarchyList, setHierarchyList] = useState([]);
  const [UOMList, setUOMList] = useState([]);
  const [showMoreTaskDetails, setShowMoreTaskDetails] = useState(false);
  const workOrderJobPlanRef = useRef(null);
  //const [form] = useForm();
  useEffect(() => {
    // ComponentDidMount equivalent
    const fetchData = async () => {
      if (workOrderJobPlanRef.current) {
        workOrderJobPlanRef.current.setFieldsValue(props.formObject);
      }

      try {
        const SkillTypeList = await getSkillTypeList();
        setSkillTypeList(SkillTypeList);
      } catch (error) {
        message.warning(`${error.message}`);
      }

      try {
        const deviceResponse = await getDeviceList();
        setDeviceList(deviceResponse.data);
      } catch (error) {
        message.warning(`${error.message}`);
      }

      try {
        const usersResponse = await getUsersList();
        setUsersList(usersResponse);
      } catch (error) {
        message.warning(`${error.message}`);
      }

      // try {
      //   const organisationsResponse = await getOrganisationsList();
      //   setOrganisationsList(organisationsResponse.data);
      // } catch (error) {
      //   message.warning(`${error.message}`);
      // }

      // try {
      //   const sitesResponse = await getSitesList();
      //   setSitesList(sitesResponse.data);
      // } catch (error) {
      //   message.warning(`${error.message}`);
      // }

      try {
        let taskResponse = await getTaskList('Active');
        taskResponse = filterTaskByReference(taskResponse, recordData);
        setTaskList(taskResponse);
      } catch (error) {
        message.warning(`${error.message}`);
      }

      // try {
      //   const hierarchyResponse = await getHierarchyList();
      //   setHierarchyList(hierarchyResponse);
      // } catch (error) {
      //   message.warning(`${error.message}`);
      // }

      try {
        const uomResponse = await _getUOMList();
        setUOMList(uomResponse);
      } catch (error) {
        message.warning(`${error.message}`);
      }
    };

    fetchData();
  }, []);

  useEffect(() => {
    if (props.formObject && Object.keys(props.formObject).length === 0 && Object.keys(formObject).length === 0) {
      onReset();
    }

    if (props.formObject && Object.keys(props.formObject).length === 0) {
      if (workOrderJobPlanRef.current) {
        workOrderJobPlanRef.current.setFieldsValue(props.formObject);
      }
    }

    if (props.translationCache !== translationCache) {
      setTranslationCache(props.translationCache);
    }

    if (props.formObject !== formObject) {
      if (workOrderJobPlanRef.current) {
        workOrderJobPlanRef.current.setFieldsValue(props.formObject);
      }
      setFormObject(props.formObject);
      setRecordData(props.formObject && props.formObject.TaskData ? props.formObject.TaskData : []);
      setWorkOrderStatus(props.workOrderStatus || null);
      setFileData(props.fileData || null);
    }
  }, [props, translationCache]);
  

  const handleChange = (value, key) => {
    setFormObject((prev) => ({
      ...prev,
      [key]: value
    }));
    setFormObject((prev) => {
      workOrderJobPlanRef.current.setFieldsValue(prev);
      return prev;
    });
  };

  const onReset = () => {
    workOrderJobPlanRef.current.resetFields();
  };

  const actualTaskOnChange = async (value) => {
    // let TaskData = await getTaskById(value, 'withoutId');
    // let data = workOrderJobPlanRef.current.getFieldsValue().ActualTaskData;
    // _.cloneDeepWith(TaskData, (value) => {
    //   return value !== null && value.StartTime
    //     ? {
    //       ...value,
    //       ...(value['StartTime'] = dayjs.utc(value.StartTime, 'YYYY-MM-DD HH:mm:ss')),
    //       ...(value['EndTime'] = dayjs.utc(value.EndTime, 'YYYY-MM-DD HH:mm:ss'))
    //     }
    //     : _.noop();
    // });
    // data.push(TaskData);
    // let FormObject = workOrderJobPlanRef.current.getFieldsValue().ActualTaskData;
    // FormObject = {
    //   ...FormObject,
    //   ActualTaskData: data
    // };

    // // setState({ selectedTask: value });
    // //    setState({ FormObject: { ...state.FormObject, ["TaskData"]: data }, selectedTask: value })
    // workOrderJobPlanRef.current.setFieldsValue(FormObject);
    // // this.workOrderJobPlanRef.current.setFieldsValue({ "TaskData": data })
   
  const TaskData = await getTaskById(value, 'withoutId');
  const existingTaskData = workOrderJobPlanRef.current?.getFieldValue()?.ActualTaskData || [];
  const data = Array.isArray(existingTaskData) ? existingTaskData : [];
  let updatedTaskData = _.cloneDeep(TaskData);

  
  updatedTaskData.TaskName = updatedTaskData.TaskName || '';
  updatedTaskData.TaskDescription = updatedTaskData.TaskDescription || '';

  if (updatedTaskData.StartTime) {
    updatedTaskData.StartTime = dayjs.utc(updatedTaskData.StartTime, 'YYYY-MM-DD HH:mm:ss');
  }
  if (updatedTaskData.EndTime) {
    updatedTaskData.EndTime = dayjs.utc(updatedTaskData.EndTime, 'YYYY-MM-DD HH:mm:ss');
  }
  data.push(updatedTaskData);

  const formValues = { ...formObject, ActualTaskData: data };
  setFormObject(formValues);
  workOrderJobPlanRef.current.setFieldsValue(formValues);

};


  const TaskOnChange = async (value) => {
    const TaskData = await getTaskById(value, 'withoutId');
    const existingTaskData = workOrderJobPlanRef.current?.getFieldsValue()?.TaskData || [];
    const data = Array.isArray(existingTaskData) ? existingTaskData : [];
    const updatedTaskData = _.cloneDeep(TaskData);
    if (updatedTaskData.StartTime) {
      updatedTaskData.StartTime = dayjs.utc(updatedTaskData.StartTime, 'YYYY-MM-DD HH:mm:ss');
    }
    if (updatedTaskData.EndTime) {
      updatedTaskData.EndTime = dayjs.utc(updatedTaskData.EndTime, 'YYYY-MM-DD HH:mm:ss');
    }
    data.push(updatedTaskData);
    const formValues = { ...formObject, TaskData: data };
    setFormObject(formValues);
    workOrderJobPlanRef.current.setFieldsValue(formValues);
  };

  const handleSelect = (value, mainIndex, subindex, keyName, selectedObject) => {
    const formValues = workOrderJobPlanRef.current.getFieldValue();
    const TaskData = formValues.TaskData;
    TaskData.forEach((item, index) => {
      if (index === mainIndex) {
        const newItem = { ...item };
        if (keyName === 'Labor') {
          const skill = SkillTypeList.find(
            st => st.Id === selectedObject[0]?.SkillTypeId
          );
          newItem[keyName][subindex] = {
            ...newItem[keyName][subindex],
            SkillTypeId: skill?.Type || null,
            Description: selectedObject[0]?.Description,
            AvailableQuantity: selectedObject[0]?.AvailableQuantity
          };
        } else {
          newItem[keyName][subindex] = {
            ...newItem[keyName][subindex],
            Description: selectedObject[0]?.Description,
            AvailableQuantity: selectedObject[0]?.AvailableQuantity
          };
        }
        TaskData[index] = newItem;
      }
    });
    workOrderJobPlanRef.current.setFieldsValue({ TaskData });
    setFormObject(prev => ({ ...prev, TaskData }));
  };

  const handleStartTimeChange = (date, index) => {

    const formObject = workOrderJobPlanRef.current.getFieldsValue();
    if (!formObject.TaskData) formObject.TaskData = [];
    if (!formObject.TaskData[index]) formObject.TaskData[index] = {};

    formObject.TaskData[index].StartTime = date;
    workOrderJobPlanRef.current.setFieldsValue(formObject);
    calculateEstimatedDuration(index);
  };



  const handleEndTimeChange = (date, index) => {

    const formObject = workOrderJobPlanRef.current.getFieldsValue();
    if (!formObject.TaskData) formObject.TaskData = [];
    if (!formObject.TaskData[index]) formObject.TaskData[index] = {};

    formObject.TaskData[index].EndTime = date;
    workOrderJobPlanRef.current.setFieldsValue(formObject);
    calculateEstimatedDuration(index);
  };
  

  const calculateEstimatedDuration = (index) => {
    const formObject = workOrderJobPlanRef.current.getFieldsValue();
    if (!formObject.TaskData?.[index]) return;

    const { StartTime, EndTime } = formObject.TaskData[index];
    let EstimatedDuration = null;

    if (StartTime && EndTime) {
      const ms = dayjs(EndTime).diff(dayjs(StartTime));
      if (ms > 0) {
        const d = dayjs.duration(ms);
        EstimatedDuration = Math.floor(d.asHours()) + dayjs.utc(ms).format(':mm:ss');
      }
    }
    formObject.TaskData[index].EstimatedDuration = EstimatedDuration;
    workOrderJobPlanRef.current.setFieldsValue(formObject);
  };

 const getDisabledHours = (e, index, key) => {
  let hours = [];
  let minutes = [];
  let StartDateTime = '';
  let EndDateTime = '';

  if (key === 'StartTime') {
    StartDateTime = dayjs(e).format('YYYY-MM-DD HH:mm');
    EndDateTime = dayjs(
      workOrderJobPlanRef.current?.getFieldValue()?.TaskData?.[index]?.EndTime,
      'YYYY-MM-DD HH:mm'
    ).local();

    if (dayjs(StartDateTime).isSame(dayjs(EndDateTime), 'day')) {
      for (let i = 0; i <= 24; i++) {
        if (i > dayjs(EndDateTime).hour()) {
          hours.push(i);
        }
      }
      if (dayjs(StartDateTime).isSame(dayjs(EndDateTime), 'day')) {
        for (let j = 0; j < 60; j++) {
          if (j > dayjs(EndDateTime).minute() - 1) {
            minutes.push(j);
          }
        }
      }
    }
  } else if (key === 'EndTime') {
    const startTime = workOrderJobPlanRef.current?.getFieldValue()?.TaskData?.[index]?.StartTime;
    if (startTime) {
      StartDateTime = dayjs(startTime).format('YYYY-MM-DD HH:mm');
      EndDateTime = dayjs(e).format('YYYY-MM-DD HH:mm');

      if (dayjs(StartDateTime).isSame(dayjs(EndDateTime), 'day')) {
        for (let k = 0; k < dayjs(StartDateTime).hour(); k++) {
          hours.push(k);
        }
        if (dayjs(StartDateTime).isSame(dayjs(EndDateTime), 'day')) {
          for (let K = 0; K < dayjs(StartDateTime).minute() + 1; K++) {
            minutes.push(K);
          }
        }
      }
    }
  }

  return {
    disabledHours: () => hours,
    disabledMinutes: () => minutes
  };
};

  // const getDisabledHours = (e, index, key) => {
  //   let hours = [];
  //   let minutes = [];
  //   let StartDateTime = '';
  //   let EndDateTime = '';
  //   let StartDate = '';
  //   let EndDate = '';

  //   if (key === 'StartTime') {
  //     StartDateTime = dayjs(e).format('YYYY-MM-DD HH:mm');
  //     EndDateTime = dayjs
  //       .utc(
  //         workOrderJobPlanRef.current.getFieldValue() &&
  //         workOrderJobPlanRef.current.getFieldValue().TaskData &&
  //         workOrderJobPlanRef.current.getFieldValue().TaskData[index] &&
  //         workOrderJobPlanRef.current.getFieldValue().TaskData[index]['EndTime'],
  //         'YYYY-MM-DD HH:mm'
  //       )
  //       .local();

  //     StartDate = dayjs(e).format('YYYY-MM-DD');
  //     EndDate = dayjs
  //       .utc(
  //         workOrderJobPlanRef.current.getFieldValue() &&
  //         workOrderJobPlanRef.current.getFieldValue().TaskData &&
  //         workOrderJobPlanRef.current.getFieldValue().TaskData[index] &&
  //         workOrderJobPlanRef.current.getFieldValue().TaskData[index]['EndTime']
  //       )
  //       .local()
  //       .format('YYYY-MM-DD');
  //   } else if (key === 'EndTime') {
  //     StartDateTime = dayjs
  //       .utc(
  //         workOrderJobPlanRef.current.getFieldValue() &&
  //         workOrderJobPlanRef.current.getFieldValue().TaskData &&
  //         workOrderJobPlanRef.current.getFieldValue().TaskData[index] &&
  //         workOrderJobPlanRef.current.getFieldValue().TaskData[index]['StartTime'],
  //         'YYYY-MM-DD HH:mm'
  //       )
  //       .local();
  //     EndDateTime = dayjs(e).format('YYYY-MM-DD HH:mm');

  //     StartDate = dayjs
  //       .utc(
  //         workOrderJobPlanRef.current.getFieldValue() &&
  //         workOrderJobPlanRef.current.getFieldValue().TaskData &&
  //         workOrderJobPlanRef.current.getFieldValue().TaskData[index] &&
  //         workOrderJobPlanRef.current.getFieldValue().TaskData[index]['StartTime']
  //       )
  //       .local()
  //       .format('YYYY-MM-DD');
  //     EndDate = dayjs(e).format('YYYY-MM-DD');
  //   }
  //   if (
  //     key === 'StartTime' &&
  //     dayjs(StartDate).isSame(
  //       dayjs(EndDate) || dayjs(StartDateTime).hours() === dayjs(EndDateTime).hours()
  //     )
  //   ) {
  //     for (var i = 0; i <= 24; i++) {
  //       if (i > dayjs(EndDateTime).hours()) {
  //         hours.push(i);
  //       }
  //     }
  //     if (dayjs(StartDate).isSame(dayjs(EndDate))) {
  //       for (var j = 0; j <= 60; j++) {
  //         if (j > dayjs(EndDateTime).minutes() - 1) {
  //           minutes.push(j);
  //         }
  //       }
  //     }
  //     return {
  //       disabledHours: () => hours,
  //       disabledMinutes: () => minutes
  //     };
  //   } else if (
  //     key === 'EndTime' &&
  //     dayjs(StartDate).isSame(
  //       dayjs(EndDate) || dayjs(StartDateTime).hours() === dayjs(EndDateTime).hours()
  //     )
  //   ) {
  //     for (var k = 0; k < dayjs(StartDateTime).hours(); k++) {
  //       if (k < 25) {
  //         hours.push(k);
  //       }
  //     }

  //     if (dayjs(StartDate).isSame(dayjs(EndDate))) {
  //       for (var K = 0; K < dayjs(StartDateTime).minutes() + 1; K++) {
  //         if (K < 61) {
  //           minutes.push(K);
  //         }
  //       }
  //     }
  //     return {
  //       disabledHours: () => hours,
  //       disabledMinutes: () => minutes
  //     };
  //   }
  // };

  const taskFileupload = async (values, key, fileDataObject, index, TaskId, submodule) => {
    const formValues = workOrderJobPlanRef.current.getFieldsValue();
    if (formValues[submodule]?.[index]?.[key]) {
      formValues[submodule][index][key].push(...values);
    } else if (formValues[submodule]?.[index] !== undefined) {
      formValues[submodule][index][key] = values;
    } else {
      formValues[submodule].push({ [key]: values });
    }
    const TaskData = [...(fileUploadList?.TaskData || [])];
    TaskData.push({ fileDataObject, TaskId });
    setFileUploadList({ ...fileUploadList, TaskData });
    workOrderJobPlanRef.current.setFieldsValue(formValues);
    setFormObject(formValues);
  };

  const disabledDate = (currentDay) => {
    return currentDay > dayjs().endOf('day');
  };
  const disabledTime = (date) => {
    return {
      disabledHours: () => getDisabledHours(date),
      disabledMinutes: (selectedHour) => getDisabledMinutes(date, selectedHour),
      disabledSeconds: () => []
    };
  };

  const getDisabledMinutes = (selectedHour) => {
    const minutes = [];
    if (selectedHour === dayjs().hour()) {
      for (let i = 0; i < dayjs().minute(); i++) {
        minutes.push(i);
      }
    }
    return minutes;
  };
  const onDrawerCancel = () => {
    setVisible(false);
  };

  const hierarchyDropdownChange = (value) => {
    const formValues = workOrderJobPlanRef.current.getFieldValue('TaskData');
    formValues.forEach((item) => {
      item.Equipment = value.Code;
    });
    setFormObject((prev) => ({
      ...prev,
      TaskData: formValues
    }));
    workOrderJobPlanRef.current.setFieldsValue({ TaskData: formValues });
  };

  const styledCollapse = (formObject, key, translationCache) => (
    <span>
      <span style={{ fontWeight: 'bold' }}>{translation(translationCache, 'Task Name')}</span>:
      <span style={{ color: 'white', margin: '0px 8px' }}>
        {formObject?.TaskData?.[key]?.TaskName || ''}
      </span>
      <span style={{ fontWeight: 'bold' }}>
        {translation(translationCache, 'Task Description')}
      </span>
      :
      <span style={{ color: 'white', margin: '0px 8px' }}>
        {formObject?.TaskData?.[key]?.TaskDescription || ''}
      </span>
    </span>
  );

  const validateMessages = {
    required: '${label} is required!',
    types: {
      email: '${label} is not a valid email!',
      number: '${label} is not a valid number!'
    },
    number: {
      range: '${label} must be between ${min} and ${max}'
    },
    pattern: {
      mismatch: '${label} does not match pattern'
    }
  };

  return (
    <div>
      <Form
        ref={workOrderJobPlanRef}
        name={'TaskData'}
        initialValues={formObject}
        layout="horizontal"
        labelCol={{ flex: '130px' }}
        labelAlign="right"
        labelWrap
        validateMessages={validateMessages}>
        {props.noJobplan === false ? (
          <div style={{ display: 'flex', flexWrap: 'wrap' }}>
            <Form.Item
              label={translation(translationCache, constant.jobPlan)}
              name="JobPlanName"
              style={{ width: '100%', flex: '50%' }}>
              <InputComponent
                placeholder={translation(translationCache, 'InputComponent JobPlan')}
                style={{ width: '70%' }}
                value={formObject?.JobPlanName || ''}
                onChange={(e) => handleChange(e.target.value, 'JobPlanName')}
              />
            </Form.Item>
            <Form.Item
              label={translation(translationCache, constant.description)}
              name="JobPlanDescription"
              style={{ width: '100%', flex: '50%' }}>
              <InputComponent
                placeholder={translation(translationCache, 'InputComponent Description')}
                style={{ width: '70%' }}
                onChange={(e) => handleChange(e.target.value, 'JobPlanDescription')}
              />
            </Form.Item>
          </div>
        ) : null}
        <Tabs defaultActiveKey="1" type="card">
          <TabPane
            className={workOrderStatus && workOrderStatus === 3 ? 'checkTab' : 'testt'}
            tab={translation(translationCache, 'Planned Task')}
            key="1">
            <Form.List initialValue={formObject && formObject.TaskData || []} name="TaskData">
              {(fields, { add, remove }) => (
                <>
                  <div style={{ display: 'flex', flexWrap: 'wrap' }}>
                    <Form.Item
                      style={{ width: '100%', flex: '50%' }}
                      label={translation(translationCache, constant.addTask)}
                      name="TaskName">
                      <Select
                        placeholder={translation(translationCache, 'Select Task')}
                        defaultValue={props.selectedTask}
                        onChange={TaskOnChange}
                        style={{ width: '70%' }}
                        dropdownRender={(menu) => (
                          <>
                            {menu}
                            <Divider style={{ margin: '8px 0' }} />
                            <Space style={{ padding: '0 8px 4px' }}>
                              <Button type="dashed" onClick={() => add()}>
                                {translation(translationCache, constant.addNewTask)}
                              </Button>
                            </Space>
                          </>
                        )}>
                        {taskList?.map((task, index) => (
                          <Option
                            key={index}
                            value={task.Id}
                            disabled={
                              workOrderJobPlanRef && workOrderJobPlanRef.current?.getFieldValue()
                                ?.TaskData?.some((item) => item?.TaskName === task.TaskName) ||
                              false
                            }
                          >
                            {task.TaskName}
                          </Option>
                        ))}
                      </Select>
                    </Form.Item>
                    <Form.Item style={{ width: '100%', flex: '50%' }}>
                      <InputComponent style={{ display: 'none' }} />
                    </Form.Item>
                  </div>
                  {fields.length > 0 && (
                    <Collapse accordion defaultActiveKey={[]}>
                      {fields.map(({ key, name, ...restField }, index) => (
                        <Panel
                          key={name}
                          header={styledCollapse(formObject, key, translationCache)}
                          extra={
                            <Popconfirm
                              title={translation(
                                translationCache,
                                'Are you sure that you want to delete the task？'
                              )}
                              icon={<QuestionCircleOutlined style={{ color: 'red' }} />}
                              onConfirm={() => remove(name)}
                              okText={translation(translationCache, constant.yes)}
                              cancelText={translation(translationCache, constant.no)}>
                              <Tooltip
                                title={translation(translationCache, 'Delete')}
                                placement="bottom">
                                <DeleteOutlined />
                              </Tooltip>
                            </Popconfirm>
                          }>
                          <div style={{ display: 'flex', flexWrap: 'wrap' }}>
                            <Form.Item
                              style={{ width: '100%', flex: '50%' }}
                              label={translation(translationCache, constant.sequence)}
                              {...restField}
                              name={[name, 'PlannedSequence']}>
                              <InputComponent
                                type="number"
                                placeholder={translation(translationCache, 'PlannedSequence')}
                                style={{ width: '70%' }}
                              />
                            </Form.Item>
                            <Form.Item
                              style={{ width: '100%', flex: '50%' }}
                              label={translation(translationCache, constant.name)}
                              {...restField}
                              name={[name, 'TaskName']}
                              rules={[{ required: true }]}>
                              <InputComponent
                                placeholder={translation(translationCache, 'Name')}
                                style={{ width: '70%' }}
                              />
                            </Form.Item>
                            <Form.Item
                              style={{ width: '100%', flex: '50%' }}
                              label={translation(translationCache, constant.description)}
                              {...restField}
                              name={[name, 'TaskDescription']}
                              rules={[{ required: true }]}>
                              <InputComponent
                                placeholder={translation(translationCache, 'Description')}
                                style={{ width: '70%' }}
                              />
                            </Form.Item>
                            <Form.Item
                            
                                style={{ width: '100%', flex: '50%' }}
                                label={translation(translationCache, constant.startTime)}
                                {...restField}
                                name={[name, 'StartTime']}>
                                <DatePicker
                                  placeholder={translation(translationCache, constant.selectDate)}
                                  inputReadOnly={true}
                                  style={{ width: '70%' }}
                                  format="YYYY-MM-DD HH:mm:ss"
                                  showTime={true}
                                  disabledDate={(d) => {
                                   
                                    return !d || d.isAfter(dayjs());
                                  }}

                                  onChange={(date) => handleStartTimeChange(date, index,'TaskData')}
                                />
                              </Form.Item>

                             <Form.Item
                              style={{ width: '100%', flex: '50%' }}
                              label={translation(translationCache, constant.endTime)}
                              {...restField}
                              name={[name, 'EndTime']}>
                              <DatePicker
                                placeholder={translation(translationCache, constant.selectDate)}
                                inputReadOnly={true}
                                style={{ width: '70%' }}
                                format="YYYY-MM-DD HH:mm:ss"
                                disabledDate={(d) => {
                                const startTime = workOrderJobPlanRef.current?.getFieldValue()?.TaskData?.[key]?.StartTime;
                                return !d || (startTime && d.isBefore(dayjs(startTime, 'YYYY-MM-DD HH:mm:ss'), 'day'));
                              }}

                                // onChange={(date, dateString) => datepickerchange(date, dateString, key, 'EndTime')}
                                onChange={(date) => handleEndTimeChange(date, index,'TaskData')}
                                disabledTime={(date) => getDisabledHours(date, index, 'EndTime')}
                                disabled={!workOrderJobPlanRef.current?.getFieldValue()?.TaskData?.[index]?.StartTime}
                                showTime={{ defaultValue: dayjs('00:00:00', 'HH:mm:ss') }}
                              />
                            </Form.Item>
                             

                            <Form.Item
                              style={{ width: '100%', flex: '50%' }}
                              label={translation(translationCache, constant.estimatedDuration)}
                              {...restField}
                              name={[name, 'EstimatedDuration']}
                            >
                              <InputComponent
                                style={{ width: '70%' }}
                                placeholder={translation(translationCache, 'EstimatedDuration')}
                                // onKeyPress={(event) => {
                                //   if (/[a-z|| A-Z || -]/.test(event.key)) {
                                //     event.preventDefault();
                                //   }
                                // }}
                                disabled
                              />
                            </Form.Item>
                            {showMoreTaskDetails && (
                              <>
                                {workOrderStatus === 'CLOSE' && (
                                  <>
                                    <Form.Item
                                      style={{ width: '100%', flex: '50%' }}
                                      label={translation(
                                        translationCache,
                                        constant.actualStartTime
                                      )}
                                      {...restField}
                                      name={[name, 'ActualStartTime']}>
                                      <DatePicker
                                        placeholder={translation(
                                          translationCache,
                                          constant.selectDate
                                        )}
                                        inputReadOnly={true}
                                        style={{ width: '70%' }}
                                        format="YYYY-MM-DD HH:mm:ss"
                                        showTime={{ defaultValue: dayjs('00:00:00', 'HH:mm:ss') }}
                                        disabledDate={disabledDate}
                                         onChange={(date) => {
                                          const formValues = workOrderJobPlanRef.current.getFieldsValue();
                                          formValues.TaskData[index].ActualStartTime = date;
                                          workOrderJobPlanRef.current.setFieldsValue(formValues);
                                        }}
                                      />
                                    </Form.Item>                              
                                    <Form.Item
                                      style={{ width: '100%', flex: '50%' }}
                                      label={translation(translationCache, constant.actualEndTime)}
                                      {...restField}
                                      name={[name, 'ActualEndTime']}>
                                      <DatePicker
                                        placeholder={translation(
                                          translationCache,
                                          constant.selectDate
                                        )}
                                        inputReadOnly={true}
                                        style={{ width: '70%' }}
                                        format="YYYY-MM-DD HH:mm:ss"
                                        showTime={{ defaultValue: dayjs('00:00:00', 'HH:mm:ss') }}
                                        //disabledDate={disabledDate}
                                        disabledDate={(current) => {
                                        const actualStartTime = workOrderJobPlanRef.current?.getFieldValue()?.TaskData?.[index]?.ActualStartTime;
                                        if (!actualStartTime) return false;
                                        return current && dayjs(current).isBefore(dayjs(actualStartTime), 'day');
                                         }}

                                         disabledTime={(current) => {
                                        const actualStartTime = workOrderJobPlanRef.current?.getFieldValue()?.TaskData?.[index]?.ActualStartTime;
                                        if (!actualStartTime || !current) return {};
                                        const start = dayjs(actualStartTime);
                                        const currentDay = dayjs(current);
                                        if (!start.isSame(currentDay, 'day')) {
                                          return {};
                                        }
                                        const disabledHours = [];
                                        for (let i = 0; i < start.hour(); i++) {
                                          disabledHours.push(i);
                                        }
                                        const disabledMinutes = (selectedHour) => {
                                          if (selectedHour === start.hour()) {
                                            const mins = [];
                                            for (let i = 0; i < start.minute(); i++) {
                                              mins.push(i);
                                            }
                                            return mins;
                                          }
                                          return [];
                                        };
                                        return {
                                          disabledHours: () => disabledHours,
                                          disabledMinutes,
                                          disabledSeconds: () => []
                                        };
                                      }}
                                       />
                                    </Form.Item>
                                  </>
                                )}
                                <Form.Item
                                  style={{ width: '100%', flex: '50%' }}
                                  label={translation(translationCache, constant.UOM)}
                                  {...restField}
                                  name={[name, 'UOM']}>
                                  <Select
                                    style={{ width: '70%' }}
                                    showArrow
                                    showSearch
                                    openOnFocus
                                    placeholder={translation(translationCache, 'UOM')}
                                    filterOption={(InputComponent, option) =>
                                      option.props.children
                                        .toLowerCase()
                                        .indexOf(InputComponent.toLowerCase()) >= 0
                                    }>
                                    {UOMList?.map((uom, index) => (
                                      <Option key={index} value={uom.UOM}>
                                        {uom.UOM}
                                      </Option>
                                    ))}
                                  </Select>
                                </Form.Item>
                                <Form.Item
                                  style={{ width: '100%', flex: '50%' }}
                                  label={translation(translationCache, constant.observation)}
                                  {...restField}
                                  name={[name, 'Observation']}>
                                  <InputComponent
                                    placeholder={translation(translationCache, 'Observation')}
                                    style={{ width: '70%' }}
                                  />
                                </Form.Item>
                                <Form.Item
                                  style={{ width: '100%', flex: '50%' }}
                                  label={translation(translationCache, constant.criteria)}
                                  {...restField}
                                  name={[name, 'Criteria']}>
                                  <InputComponent
                                    placeholder={translation(translationCache, 'Criteria')}
                                    style={{ width: '70%' }}
                                  />
                                </Form.Item>
                                <Form.Item
                                  style={{ width: '100%', flex: '50%' }}
                                  label={translation(translationCache, constant.recordBy)}
                                  {...restField}
                                  name={[name, 'RecordBy']}>
                                  <Select
                                    placeholder={translation(translationCache, 'Select RecordBy')}
                                    style={{ width: '70%' }}>
                                    {usersList?.map((item, index) => (
                                      <Option key={index} value={item.FirstName}>
                                        {item.FirstName}
                                      </Option>
                                    ))}
                                  </Select>
                                </Form.Item>
                                <Form.Item
                                  style={{ width: '100%', flex: '50%' }}
                                  label={translation(translationCache, constant.checkedBy)}
                                  {...restField}
                                  name={[name, 'CheckedBy']}>
                                  <Select
                                    placeholder={translation(translationCache, 'Select CheckedBy')}
                                    style={{ width: '70%' }}>
                                    {usersList?.map((item, index) => (
                                      <Option key={index} value={item.Id}>
                                        {item.FirstName}
                                      </Option>
                                    ))}
                                  </Select>
                                </Form.Item>
                                <Form.Item
                                  label={translation(translationCache, constant.attachments)}
                                  style={{ width: '100%', flex: '50%' }}>
                                  <FileBase64
                                    Attachments={formObject?.TaskData?.[key]?.Attachments || []}
                                    disableAdd={!formObject?.TaskData?.[key]?.Id}
                                    name={key}
                                    fileUpload={(values, key, fileDataObject) => {
                                      taskFileupload(
                                        values,
                                        key,
                                        fileDataObject,
                                        index,
                                        formObject?.TaskData?.[index]?.Id || '',
                                        'TaskData'
                                      );
                                    }}
                                  />
                                </Form.Item>
                              </>
                            )}
                            <span style={{ width: '100%', flex: '50%' }}></span>
                            <span style={{ width: '100%', flex: '50%', color: 'white' }}>
                              <div
                                style={{
                                  display: 'flex',
                                  justifyContent: 'flex-end',
                                  width: '74%',
                                  cursor: 'pointer',
                                  color: '#d98e04',
                                  fontWeight: 'bold'
                                }}
                                onClick={() => setShowMoreTaskDetails(!showMoreTaskDetails)}>
                                <u>{showMoreTaskDetails ? 'Show less' : 'Show more'}</u>
                              </div>
                            </span>
                            <Drawer
                              open={visible}
                              width={1000}
                              closable
                              title="Hierarchy"
                              onClose={onDrawerCancel}>
                              <HierarchyModal
                                value={deviceId}
                                treeData={treeData}
                                translationCache={props.translationCache}
                                language={props.language}
                                fieldKey={name}
                                handleDropdownChange={hierarchyDropdownChange}
                                deviceList={deviceList}
                              />
                            </Drawer>
                          </div>
                          <Tabs
                            defaultActiveKey="1"
                            type="card"
                            >
                            <TabPane tab={translation(translationCache, constant.tool)} key="1">
                              <Col span={24}>
                                <Form.Item>
                                  <Toolsform
                                    form={workOrderJobPlanRef.current}
                                    fieldKey={name}
                                    formObject={
                                      workOrderJobPlanRef.current?.getFieldsValue() || {}
                                    }
                                    onToolChange={handleSelect}
                                  />
                                </Form.Item>
                              </Col>
                            </TabPane>
                            <TabPane tab={translation(translationCache, constant.labor)} key="2">
                              <Col span={24}>
                                <Form.Item>
                                  <LaborForm
                                    fieldKey={name}
                                    formObject={
                                      workOrderJobPlanRef.current?.getFieldsValue() || {}
                                    }
                                    onLaborChange={handleSelect}
                                  />
                                </Form.Item>
                              </Col>
                            </TabPane>
                            <TabPane
                              tab={translation(translationCache, constant.material)}
                              key="3">
                              <Col span={24}>
                                <Form.Item>
                                  <MaterialForm
                                    fieldKey={name}
                                    formObject={
                                      workOrderJobPlanRef.current?.getFieldsValue() || {}
                                    }
                                    onMaterialChange={handleSelect}
                                  />
                                </Form.Item>
                              </Col>
                            </TabPane>
                            <TabPane tab={translation(translationCache, constant.items)} key="4">
                              <Col span={24}>
                                <Form.Item>
                                  <ItemForm
                                    fieldKey={name}
                                    formObject={
                                      workOrderJobPlanRef.current?.getFieldsValue() || {}
                                    }
                                    onItemChange={handleSelect}
                                  />
                                </Form.Item>
                              </Col>
                            </TabPane>
                            <TabPane tab={translation(translationCache, constant.fieldDataType)} key="5">
                              <Col span={24}>
                                <Form.Item>
                                  <FieldTypeForm
                                    fieldKey={name}
                                    formObject={
                                      workOrderJobPlanRef.current?.getFieldsValue() || {}
                                    }
                                  />
                                </Form.Item>
                              </Col>
                            </TabPane>
                          </Tabs>
                        </Panel>
                      ))}
                    </Collapse>
                  )}
                </>
              )}
            </Form.List>
          </TabPane>
          <TabPane tab={translation(translationCache, 'Actual Task')} key="2">
           
              <Form.List  initialValue={formObject && formObject.ActualTaskData || []} name="ActualTaskData">
                {(fields, { add, remove }) => (
                  <>
                    <div style={{ display: 'flex', flexWrap: 'wrap' }}>
                      <Form.Item
                        style={{ width: '100%', flex: '50%' }}
                        label={translation(translationCache, constant.addTask)}
                        name="TaskName">
                        <Select
                          placeholder={translation(translationCache, 'Select Task')}
                          defaultValue={props.selectedTask}
                          onChange={actualTaskOnChange}
                          style={{ width: '70%' }}
                          dropdownRender={(menu) => (
                            <>
                              {menu}
                              <Divider style={{ margin: '8px 0' }} />
                              <Space style={{ padding: '0 8px 4px' }}>
                                <Button type="dashed" onClick={() => add()}>
                                  {translation(translationCache, constant.addNewTask)}
                                </Button>
                              </Space>
                            </>
                          )}>
                          {taskList?.map((task, index) => (
                            <Option
                              key={index}
                              value={task.Id}
                              // disabled={
                              //   workOrderJobPlanRef.current
                              //     ?.getFieldsValue()
                              //     ?.ActualTaskData?.some(
                              //       (item) => item?.TaskName === task.TaskName
                              //     ) || false
                              // }
                               disabled={
                                      workOrderJobPlanRef.current &&
                                      workOrderJobPlanRef.current.getFieldsValue() &&
                                      workOrderJobPlanRef.current.getFieldsValue()
                                        .ActualTaskData &&
                                      workOrderJobPlanRef.current
                                        .getFieldsValue()
                                        .ActualTaskData.filter(
                                          (item) =>
                                            item &&
                                            item !== undefined &&
                                            item.TaskName === task.TaskName
                                        ).length > 0
                                        ? true
                                        : false
                                    }>
                              {task.TaskName}
                            </Option>
                          ))}
                        </Select>
                      </Form.Item>
                      <Form.Item style={{ width: '100%', flex: '50%' }}>
                        <InputComponent style={{ display: 'none' }} />
                      </Form.Item>
                    </div>
                    {fields.length > 0 && (
                      <Collapse accordion defaultActiveKey={[]}>
                        {fields.map(({ key, name, ...restField }, index) => (
                          <Panel
                            key={name}
                            header={styledCollapse(formObject, key, translationCache)}
                            extra={
                              <Popconfirm
                                title={translation(
                                  translationCache,
                                  'Are you sure that you want to delete the task？'
                                )}
                                icon={<QuestionCircleOutlined style={{ color: 'red' }} />}
                                onConfirm={() => remove(name)}
                                okText={translation(translationCache, constant.yes)}
                                cancelText={translation(translationCache, constant.no)}>
                                <Tooltip
                                  title={translation(translationCache, 'Delete')}
                                  placement="bottom">
                                  <DeleteOutlined />
                                </Tooltip>
                              </Popconfirm>
                            }>
                            <div style={{ display: 'flex', flexWrap: 'wrap' }}>
                              <Form.Item
                                style={{ width: '100%', flex: '50%' }}
                                label={translation(translationCache, constant.sequence)}
                                {...restField}
                                name={[name, 'PlannedSequence']}>
                                <InputComponent
                                  type="number"
                                  placeholder={translation(translationCache, 'PlannedSequence')}
                                  style={{ width: '70%' }}
                                />
                              </Form.Item>
                              <Form.Item
                                style={{ width: '100%', flex: '50%' }}
                                label={translation(translationCache, constant.name)}
                                {...restField}
                                name={[name, 'TaskName']}
                                rules={[{ required: true }]}>
                                <InputComponent
                                  placeholder={translation(translationCache, 'Name')}
                                  style={{ width: '70%' }}
                                />
                              </Form.Item>
                              <Form.Item
                                style={{ width: '100%', flex: '50%' }}
                                label={translation(translationCache, constant.description)}
                                {...restField}
                                name={[name, 'TaskDescription']}
                                rules={[{ required: true }]}>
                                <InputComponent
                                  placeholder={translation(translationCache, 'Description')}
                                  style={{ width: '70%' }}
                                />
                              </Form.Item>
                               <Form.Item
                                style={{ width: '100%', flex: '50%' }}
                                label={translation(translationCache, constant.startTime)}
                                {...restField}
                                name={[name, 'StartTime']}>
                                <DatePicker
                                  placeholder={translation(translationCache, constant.selectDate)}
                                  inputReadOnly={true}
                                  style={{ width: '70%' }}
                                  format="YYYY-MM-DD HH:mm:ss"
                                  // onChange={(date, dateString) =>
                                  //   datepickerchange(date, dateString, key, 'StartTime')                                    
                                  // }
                                  onChange={(date) => handleStartTimeChange(date, index)}
                                  showTime={{ defaultValue: dayjs('00:00:00', 'HH:mm:ss') }}
                                  disabledDate={(d) => !d || d.isAfter(dayjs())} 
                                  // disabledDate={(d) =>
                                  //   !d ||
                                  //   d.isAfter(
                                  //     workOrderJobPlanRef.current.getFieldValue() &&
                                  //       workOrderJobPlanRef.current.getFieldValue().ActualTaskData &&
                                  //       workOrderJobPlanRef.current.getFieldValue().ActualTaskData[key] &&
                                  //       workOrderJobPlanRef.current.getFieldValue().ActualTaskData[key]['EndTime']
                                  //       ? dayjs(
                                  //         workOrderJobPlanRef.current.getFieldValue().ActualTaskData[key]['EndTime'],
                                  //         'YYYY-MM-DD HH:mm:ss'
                                  //       )
                                  //       : ''
                                  //   )
                                  // }

                                  disabledTime={(date) =>
                                    getDisabledHours(
                                      date,index,'StartTime'
                                    )
                                  }
                                />
                              </Form.Item> 
                           
                              <Form.Item
                                style={{ width: '100%', flex: '50%' }}
                                label={translation(translationCache, constant.endTime)}
                                {...restField}
                                name={[name, 'EndTime']}>
                                <DatePicker
                                  placeholder={translation(translationCache, constant.selectDate)}
                                  inputReadOnly={true}
                                  style={{ width: '70%' }}
                                  format="YYYY-MM-DD HH:mm:ss"
                                  // onChange={(date, dateString) =>
                                  //   datepickerchange(date, dateString, key, 'EndTime')
                                  // }
                                  onChange={(date) => handleEndTimeChange(date, index)}
                                  disabled={
                                    workOrderJobPlanRef.current &&
                                      workOrderJobPlanRef.current !== null &&
                                      workOrderJobPlanRef.current.getFieldValue() &&
                                      workOrderJobPlanRef.current.getFieldValue()
                                        .ActualTaskData &&
                                      workOrderJobPlanRef.current.getFieldValue()
                                        .ActualTaskData[key] &&
                                      workOrderJobPlanRef.current.getFieldValue()
                                        .ActualTaskData[key]['StartTime']
                                      ? false
                                      : true
                                  }
                                  // inputReadOnly={false}
                                  disabledDate={(d) =>
                                    !d ||
                                    d.isBefore(
                                      workOrderJobPlanRef.current &&
                                        workOrderJobPlanRef.current !== null &&
                                        workOrderJobPlanRef.current.getFieldValue() &&
                                        workOrderJobPlanRef.current.getFieldValue()
                                          .ActualTaskData &&
                                        workOrderJobPlanRef.current.getFieldValue()
                                          .ActualTaskData[key] &&
                                        workOrderJobPlanRef.current.getFieldValue()
                                          .ActualTaskData[key]['StartTime']
                                        ? dayjs(
                                          workOrderJobPlanRef.current.getFieldValue() &&
                                          workOrderJobPlanRef.current.getFieldValue()
                                            .ActualTaskData &&
                                          workOrderJobPlanRef.current.getFieldValue()
                                            .ActualTaskData[key] &&
                                          workOrderJobPlanRef.current.getFieldValue()
                                            .ActualTaskData[key]['StartTime']
                                        ).format('YYYY-MM-DD')
                                        : ''
                                    )
                                  }
                                  disabledTime={(date) =>
                                    getDisabledHours(
                                      date,
                                      index,
                                      'EndTime'
                                    )
                                  }
                                  showTime={{
                                    defaultValue: dayjs('00:59:59', 'HH:mm:ss')
                                  }}
                                />{' '}
                              </Form.Item> 
                         

                              
                              <Form.Item
                                style={{ width: '100%', flex: '50%' }}
                                label={translation(translationCache, constant.estimatedDuration)}
                                {...restField}
                                name={[name, 'EstimatedDuration']}>
                                <InputComponent
                                  style={{ width: '70%' }}
                                  placeholder={translation(translationCache, 'EstimatedDuration')}
                                  onKeyPress={(event) => {
                                    if (/[a-z|| A-Z || -]/.test(event.key)) {
                                      event.preventDefault();
                                    }
                                  }}
                                />
                              </Form.Item>
                              {showMoreTaskDetails && (
                                <>
                                  {workOrderStatus === 'CLOSE' && (
                                    <>
                                      <Form.Item
                                        style={{ width: '100%', flex: '50%' }}
                                        label={translation(
                                          translationCache,
                                          constant.actualStartTime
                                        )}
                                        {...restField}
                                        name={[name, 'ActualStartTime']}>
                                        <DatePicker
                                          placeholder={translation(
                                            translationCache,
                                            constant.selectDate
                                          )}
                                          inputReadOnly={true}
                                          style={{ width: '70%' }}
                                          format="YYYY-MM-DD HH:mm:ss"
                                          showTime={{ defaultValue: dayjs('00:00:00', 'HH:mm:ss') }}
                                          disabledTime={disabledTime}
                                          disabledDate={disabledDate}
                                        />
                                      </Form.Item>
                                      <Form.Item
                                        style={{ width: '100%', flex: '50%' }}
                                        label={translation(translationCache, constant.actualEndTime)}
                                        {...restField}
                                        name={[name, 'ActualEndTime']}>
                                        <DatePicker
                                          placeholder={translation(
                                            translationCache,
                                            constant.selectDate
                                          )}
                                          inputReadOnly={true}
                                          style={{ width: '70%' }}
                                          format="YYYY-MM-DD HH:mm:ss"
                                          showTime={{ defaultValue: dayjs('00:00:00', 'HH:mm:ss') }}
                                          disabledDate={disabledDate}
                                        />
                                      </Form.Item>
                                    </>
                                  )}
                                  <Form.Item
                                    style={{ width: '100%', flex: '50%' }}
                                    label={translation(translationCache, constant.UOM)}
                                    {...restField}
                                    name={[name, 'UOM']}>
                                    <Select
                                      style={{ width: '70%' }}
                                      showArrow
                                      showSearch
                                      openOnFocus
                                      placeholder={translation(translationCache, 'UOM')}
                                      filterOption={(InputComponent, option) =>
                                        option.props.children
                                          .toLowerCase()
                                          .indexOf(InputComponent.toLowerCase()) >= 0
                                      }>
                                      {UOMList?.map((uom, index) => (
                                        <Option key={index} value={uom.UOM}>
                                          {uom.UOM}
                                        </Option>
                                      ))}
                                    </Select>
                                  </Form.Item>
                                  <Form.Item
                                    style={{ width: '100%', flex: '50%' }}
                                    label={translation(translationCache, constant.observation)}
                                    {...restField}
                                    name={[name, 'Observation']}>
                                    <InputComponent
                                      placeholder={translation(translationCache, 'Observation')}
                                      style={{ width: '70%' }}
                                    />
                                  </Form.Item>
                                  <Form.Item
                                    style={{ width: '100%', flex: '50%' }}
                                    label={translation(translationCache, constant.criteria)}
                                    {...restField}
                                    name={[name, 'Criteria']}>
                                    <InputComponent
                                      placeholder={translation(translationCache, 'Criteria')}
                                      style={{ width: '70%' }}
                                    />
                                  </Form.Item>
                                  <Form.Item
                                    style={{ width: '100%', flex: '50%' }}
                                    label={translation(translationCache, constant.recordBy)}
                                    {...restField}
                                    name={[name, 'RecordBy']}>
                                    <Select
                                      placeholder={translation(translationCache, 'Select RecordBy')}
                                      style={{ width: '70%' }}>
                                      {usersList?.map((item, index) => (
                                        <Option key={index} value={item.Id}>
                                          {item.FirstName}
                                        </Option>
                                      ))}
                                    </Select>
                                  </Form.Item>
                                  <Form.Item
                                    style={{ width: '100%', flex: '50%' }}
                                    label={translation(translationCache, constant.checkedBy)}
                                    {...restField}
                                    name={[name, 'CheckedBy']}>
                                    <Select
                                      placeholder={translation(translationCache, 'Select CheckedBy')}
                                      style={{ width: '70%' }}>
                                      {usersList?.map((item, index) => (
                                        <Option key={index} value={item.Id}>
                                          {item.FirstName}
                                        </Option>
                                      ))}
                                    </Select>
                                  </Form.Item>
                                  {/* <Form.Item
                                    label="Attachments"
                                    style={{ width: '100%', flex: '50%' }}>
                                    <FileBase64
                                      disableAdd={!formObject?.ActualTaskData?.[key]?.Id}
                                      Attachments={
                                        formObject?.ActualTaskData?.[key]?.Attachments || []
                                      }
                                      name={key}
                                      fileUpload={(values, key, fileDataObject) => {
                                        taskFileupload(
                                          values,
                                          key,
                                          fileDataObject,
                                          index,
                                          formObject &&
                                            formObject &&
                                            formObject.TaskData &&
                                            formObject.TaskData[index] &&
                                            formObject.TaskData[index].Id
                                            ? formObject.TaskData[index].Id
                                            : '',
                                          'TaskData'
                                        );
                                      }}
                                    />
                                  </Form.Item> */}
                                  <Form.Item
                                    label={translation(translationCache, constant.attachments)}
                                    style={{ width: '100%', flex: '50%' }}>
                                    <FileBase64
                                      Attachments={formObject?.ActualTaskData?.[key]?.Attachments || []}
                                      disableAdd={!formObject?.ActualTaskData?.[key]?.Id}
                                      name={key}
                                      fileUpload={(values, key, fileDataObject) => {
                                        taskFileupload(
                                          values,
                                          key,
                                          fileDataObject,
                                          index,
                                          formObject?.TaskData?.[index]?.Id || '',
                                          'TaskData'
                                        );
                                      }}
                                    />
                                  </Form.Item>
                                </>
                              )}
                              <span style={{ width: '100%', flex: '50%' }}></span>
                              <span style={{ width: '100%', flex: '50%', color: 'white' }}>
                                <div
                                  style={{
                                    display: 'flex',
                                    justifyContent: 'flex-end',
                                    width: '74%',
                                    cursor: 'pointer',
                                    color: '#d98e04',
                                    fontWeight: 'bold'
                                  }}
                                  onClick={() => setShowMoreTaskDetails(!showMoreTaskDetails)}>
                                  <u>{showMoreTaskDetails ? 'Show less' : 'Show more'}</u>
                                </div>
                              </span>
                              <Drawer
                                open={visible}
                                width={1000}
                                closable
                                title="Hierarchy"
                                onClose={onDrawerCancel}
                              >
                                <HierarchyModal
                                  value={deviceId}
                                  treeData={setTreeData}
                                  translationCache={props.translationCache}
                                  language={props.language}
                                  fieldKey={name}
                                  handleDropdownChange={hierarchyDropdownChange}
                                  deviceList={setDeviceList}
                                />
                              </Drawer>
                            </div>
                            <Form style={{ padding: '0px' }}>
                              <Tabs

                                defaultActiveKey="1"
                                type="card">
                                <TabPane tab={translation(translationCache, constant.tool)} key="1">
                                  <Col span={24}>
                                    <Form.Item>
                                      <Toolsform
                                        fieldKey={name}
                                        formObject={
                                          workOrderJobPlanRef.current?.getFieldsValue() || {}
                                        }
                                        onToolChange={handleSelect}
                                      />
                                    </Form.Item>
                                  </Col>
                                </TabPane>
                                <TabPane tab={translation(translationCache, constant.labor)} key="2">
                                  <Col span={24}>
                                    <Form.Item>
                                      <LaborForm
                                        fieldKey={name}
                                        formObject={
                                          workOrderJobPlanRef.current?.getFieldsValue() || {}
                                        }
                                        onLaborChange={handleSelect}
                                      />
                                    </Form.Item>
                                  </Col>
                                </TabPane>
                                <TabPane
                                  tab={translation(translationCache, constant.material)}
                                  key="3">
                                  <Col span={24}>
                                    <Form.Item>
                                      <MaterialForm
                                        fieldKey={name}
                                        formObject={
                                          workOrderJobPlanRef.current?.getFieldsValue() || {}
                                        }
                                        onMaterialChange={handleSelect}
                                      />
                                    </Form.Item>
                                  </Col>
                                </TabPane>
                                <TabPane tab={translation(translationCache, constant.items)} key="4">
                                  <Col span={24}>
                                    <Form.Item>
                                      <ItemForm
                                        fieldKey={name}
                                        formObject={
                                          workOrderJobPlanRef.current?.getFieldsValue() || {}
                                        }
                                        onItemChange={handleSelect}
                                      />
                                    </Form.Item>
                                  </Col>
                                </TabPane>
                              </Tabs>
                            </Form>
                          </Panel>
                        ))}
                      </Collapse>
                    )}
                  </>
                )}
              </Form.List>
              
          </TabPane>
        </Tabs>
        <Form.Item style={{ display: 'flex', justifyContent: 'right' }}>
          <Button
            type="primary"
            onClick={() =>
              props.onFinish(
                workOrderJobPlanRef.current.getFieldsValue(),
                'JobPlan',
                fileData
              )
            }
            style={{ marginTop: '20px', marginBottom: '-7px' }}>
            {translation(translationCache, constant.save)}
          </Button>
        </Form.Item>
      </Form>
    </div>
  );
};

const mapStateToProps = (state) => ({
  translationCache: state.TranslationReducer.translationCache
});

export default connect(mapStateToProps)(WorkOrderJobPlanes);